export default __webpack_public_path__ + "static/media/factsheet-icon.ec1fd861.svg";